import about from "./about.json";
import rawProjects from "./projects.json";

const socials = [
  {
    name: "LinkedIn",
    label: "LinkedIn",
    link: "https://www.linkedin.com/in/jacob-m-livingston/",
  },
  {
    name: "ItchIo",
    label: "Itch.io",
    link: "https://jakeliv.itch.io",
  },
  {
    name: "Github",
    label: "GitHub",
    link: "https://github.com/jacobliv",
  },
];

const slugify = (value) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const projects = rawProjects
  .filter((project) => project.name)
  .map((project) => ({
    ...project,
    slug: slugify(project.name),
    assetDirectory: project.name.replace(/\s/g, ""),
    scaleToFit: project.scaleToFit === true || project.scaleToFit === "true",
  }));

export { about, projects, socials };
